import React from 'react';
import styles from './style.module.css';
import { OpenXLogoDarkIcon } from '../../assets';
import openXtwitter from '../../assets/socials/OpenXtwitter.svg';
import openXyoutube from '../../assets/socials/OpenXyoutube.svg';
import openXinstagram from '../../assets/socials/OpenXinstagram.svg';
import openXlinkedin from '../../assets/socials/OpenXlinkedin.svg';
import openXfacebook from '../../assets/socials/OpenXfacebook.svg';
import Typography from '../Typography/Typography';
import { useNavigate } from 'react-router';

interface FooterProps {
  className?: string;
}

export const Footer: React.FC<FooterProps> = ({ className }) => {
  const navigate = useNavigate()
  return (
    <footer className={`${styles.footer} ${className || ''}`}>
      <div className={styles.footerContainer}>
        <div className={styles.brandSection}>
          <div className={styles.logoContainer}>
            <span className={styles.logoWrapper} onClick={() => navigate('/') }>
              <img
                src={OpenXLogoDarkIcon}
                alt="OpenX Logo"
                className={styles.logoImage}
              />
            </span>
          </div>

          <Typography
            variant="bodyRegular"
            fontFamily='satoshi'
            weight="regular"
            size="base"
            className={styles.description}>
            Lets you easily showcase and sell/buy products in
            3D virtual galleries—no tech skills needed.
          </Typography>

          <div className={styles.socialLinks}>
            <a href="#twitter" className={styles.socialLink} aria-label="Twitter">
              <img src={openXtwitter} alt="Twitter" width="20" height="20" />
            </a>
            <a href="#youtube" className={styles.socialLink} aria-label="YouTube">
              <img src={openXyoutube} alt="YouTube" width="20" height="20" />
            </a>
            <a href="#instagram" className={styles.socialLink} aria-label="Instagram">
              <img src={openXinstagram} alt="Instagram" width="20" height="20" />
            </a>
            <a href="#linkedin" className={styles.socialLink} aria-label="LinkedIn">
              <img src={openXlinkedin} alt="LinkedIn" width="20" height="20" />
            </a>
            <a href="#facebook" className={styles.socialLink} aria-label="Facebook">
              <img src={openXfacebook} alt="Facebook" width="20" height="20" />
            </a>
          </div>

          <Typography
            variant="bodyRegular"
            fontFamily='satoshi'
            weight="regular"
            size="base"
            className={styles.copyright}>
            &copy; 2025 OpenX. All rights reserved.
          </Typography>
        </div>

        <div className={styles.navigationSections}>
          <div className={styles.section}>
            <Typography
              variant="bodyLarge"
              fontFamily='satoshi'
              weight="bold"
              className={styles.sectionTitle}>
              Company
            </Typography>
            <ul className={styles.linkList}>
              <li>
                <a href="/about" className={styles.link}>
                  <Typography
                    variant="bodyRegular"
                    fontFamily='satoshi'
                    weight="regular"
                    className={styles.linkText}>
                    About us
                  </Typography>
                </a>
              </li>
            </ul>
          </div>

          <div className={styles.section}>
            <Typography
              variant="bodyLarge"
              fontFamily='satoshi'
              weight="bold"
              className={styles.sectionTitle}>
              Services
            </Typography>
            <ul className={styles.linkList}>
              <li>
                <a href="/marketPlace" className={styles.link}>
                  <Typography
                    variant="bodyRegular"
                    fontFamily='satoshi'
                    weight="regular"
                    className={styles.linkText}>
                    Market
                  </Typography>
                </a>
              </li>
              <li>
                <a href="#display" className={styles.link}>
                  <Typography
                    variant="bodyRegular"
                    fontFamily='satoshi'
                    weight="regular"
                    className={styles.linkText}>
                    Display
                  </Typography>
                </a>
              </li>
              <li>
                <a href="#educate" className={styles.link}>
                  <Typography
                    variant="bodyRegular"
                    fontFamily='satoshi'
                    weight="regular"
                    className={styles.linkText}>
                    Educate
                  </Typography>
                </a>
              </li>
            </ul>
          </div>

          <div className={styles.section}>
            <Typography
              variant="bodyLarge"
              fontFamily='satoshi'
              weight="bold"
              className={styles.sectionTitle}>
              Contact
            </Typography>
            <ul className={styles.linkList}>
              <li>
                <a href="mailto:OpenX@.com" className={styles.link}>
                  <Typography
                    variant="bodyRegular"
                    fontFamily='satoshi'
                    weight="regular"
                    className={styles.linkText}>
                    OpenX@.com
                  </Typography>
                </a>
              </li>
            </ul>
          </div>

          <div className={styles.section}>
            <Typography
              variant="bodyLarge"
              fontFamily='satoshi'
              weight="bold"
              className={styles.sectionTitle}>
              Legal
            </Typography>
            <ul className={styles.linkList}>
              <li>
                <a href="#private-privacy" className={styles.link}>
                  <Typography
                    variant="bodyRegular"
                    fontFamily='satoshi'
                    weight="regular"
                    className={styles.linkText}>
                    Private Policy
                  </Typography>
                </a>
              </li>
              <li>
                <a href="#terms-conditions" className={styles.link}>
                  <Typography
                    variant="bodyRegular"
                    fontFamily='satoshi'
                    weight="regular"
                    className={styles.linkText}>
                    Terms and conditions
                  </Typography>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};